import * as React from 'react'
import { Link } from '@amzn/dvui/dist/Link'
import { Badge, badges } from '@amzn/dvui/dist/Badge'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { TextLocalizer } from '../localizer/localizer'
import { StringId } from '../localizer/stringId'
import { roundValue } from '../../utils/numberUtils'
import { withLocalization, LocalizerProps } from '../localizer/localizer'
import { safeBoolean } from '../../utils/utils'

export interface IAmazonRatingBadgeProps {
  amazonRating?: WpsRuntime.atv.wps.AmazonRatingProps,
  pageTitleId: string
  isRetail: boolean
  offerAvailableOn?: string
  comingSoonMessagesPresent?: boolean,
  isCerberusChild: boolean,
  isHover?: boolean
}

type LocalizedAmazonRatingProps = IAmazonRatingBadgeProps & LocalizerProps

const reviewsAllowed = (offerAvailableDate: string) => Date.now() > new Date(offerAvailableDate).getTime()

const reviewLink = '/review/create-review/ref=acr_dpinstantvideo_solicit?ie=UTF8&asin='

interface FirstReviewProps {
  titleId: string,
  comingSoonMessagesPresent: boolean,
  offerAvailableOn?: string
}

// Given that no reviews are currently present
const BeTheFirstToReview = ({ titleId, offerAvailableOn, comingSoonMessagesPresent }: FirstReviewProps) => {
  if (comingSoonMessagesPresent || (offerAvailableOn && !reviewsAllowed(offerAvailableOn))) {
    return null
  }

  return <Link href={`${reviewLink}${titleId}`}>
    <TextLocalizer stringID={StringId.DV_DP_first_review} />
  </Link>
}

const ratingClass = (formattedValue: number) => {
  const ratingNumbers = `${formattedValue}`.split('.')
  return ['av-stars', ...ratingNumbers].join('-')
}

const AmazonRatingWithLocalization = ({
                                        amazonRating,
                                        pageTitleId,
                                        isRetail,
                                        offerAvailableOn,
                                        comingSoonMessagesPresent = false,
                                        getString,
                                        isCerberusChild,
                                        isHover = false
}: LocalizedAmazonRatingProps) => {
  // We don't show Amazon Rating on Fogg
  if (!isRetail || global.__NATIVEAPP__) {
    return null
  }
  const value = amazonRating && amazonRating.value
  const count = amazonRating && amazonRating.count
  const countFormatted = amazonRating && amazonRating.countFormatted

  if (!count || !value) {
    if (!safeBoolean(isCerberusChild) && !isHover) {
      return <BeTheFirstToReview titleId={pageTitleId} offerAvailableOn={offerAvailableOn} comingSoonMessagesPresent={comingSoonMessagesPresent}/>
    }
    return null
  }

  const ariaLabel = getString(StringId.DV_DP_ARIA_amazon_rating, { ratingValue: roundValue(value, 10).toString(), customerCount: count.toString() })

  const rating =
    <>
      <span className={`av-icon av-icon--amazon_rating ${ratingClass(roundValue(value, 2))}`} />
      <span>({countFormatted})</span>
    </>

  const badgeContent = safeBoolean(isCerberusChild) ? rating :
    <a href="#customer-review-section" aria-label={ariaLabel}>
      {rating}
    </a>

  return (<Badge use={badges.TEXT}>
    {badgeContent}
  </Badge>)
}

export const AmazonRating = withLocalization(AmazonRatingWithLocalization)
